// List of types supported by ReactPixiFiber
export const TYPES = {
  BITMAP_TEXT: "BitmapText",
  CONTAINER: "Container",
  GRAPHICS: "Graphics",
  NINE_SLICE_PLANE: "NineSlicePlane",
  PARTICLE_CONTAINER: "ParticleContainer",
  SPRITE: "Sprite",
  TEXT: "Text",
  TILING_SPRITE: "TilingSprite",
};
